import { Box, Checkbox, FormControl } from '@primer/react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import SelectBoxMienGiam from '../../../../components/selectbox-miengiam';
import Button from '../../../../components/ui/button';
import Modal from '../../../../components/ui/modal';
import ModalActions from '../../../../components/ui/modal/ModalActions';
import Text from '../../../../components/ui/text';
import TextAreaAutoHeight from '../../../../components/ui/text-area-auto-height';
import { useCommonSelectedHook } from '../../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../../models/ePageBaseStatus';
import { IBoDoiCongAn } from '../../../../models/response/hoc-sinh/IBoDoiCongAn';
import { actions } from '../../../../state/actions/actionsWrapper';
import { RootState } from '../../../../state/reducers';
import { HocSinh } from '../../gia-dinh/QuanHeGiaDinhHocSinh';
import SelectBoxPhuHuynh from '../../../../components/selectbox-phuhuynh';
interface Props {
    hocSinh: HocSinh;
    is_th_dacbiet: boolean;
}
const ConEmBoDoiCongAnPageEditModal: React.FC<Props> = ({ hocSinh, is_th_dacbiet }) => {
    const { status, editingData } = useSelector((x: RootState) => x.boDoiCongAn)
    const dispatch = useDispatch();
    const { dm_coso_id, nam_hoc } = useCommonSelectedHook();
    const { handleSubmit, setValue, watch, control, formState: { errors } } = useForm<IBoDoiCongAn>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    })
    const onSubmit = async (data: any) => {
        dispatch(actions.boDoiCongAn.SAVE_START({
            ...data,
            id: data?.id ?? 0,
            ts_hocsinh_id: hocSinh.id,
            nam_hoc: nam_hoc
        }))
    }

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.boDoiCongAn.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>

                    {is_th_dacbiet &&
                        <FormControl>
                            <FormControl.Label>
                                Số tờ trình
                            </FormControl.Label>
                            <Controller
                                name="ma_to_trinh"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <TextAreaAutoHeight
                                            defaultValue={field.value}
                                            isAutoFocus
                                            sx={{
                                                width: "100%"
                                            }}
                                            resize="none"
                                            onValueChanged={(value) => {
                                                field.onChange(value)
                                            }}

                                        />
                                        {
                                            errors && errors["ma_to_trinh"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng nhập số tờ trình
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}

                            />
                        </FormControl>
                    }
                    {!is_th_dacbiet && <>
                        <FormControl>
                            <FormControl.Label><Text text='Phụ huynh' /></FormControl.Label>
                            <Controller
                                name="ts_phuhuynh_id"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <SelectBoxPhuHuynh
                                            isReadonly={editingData !== undefined && editingData.id > 0}
                                            value={field.value}
                                            isShowClearBtn={true}
                                            onValueChanged={(value, data) => {
                                                field.onChange(value);
                                                setValue("ten_phu_huynh", data ? data.ho_ten : '')
                                            }}
                                            width={'100%'}
                                        />
                                        {
                                            errors && errors["ts_phuhuynh_id"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng chọn phụ huynh
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}
                            />

                        </FormControl>
                        {/* <FormControl>
                            <FormControl.Label>
                                Tên phụ huynh
                            </FormControl.Label>
                            <Controller
                                name="ten_phu_huynh"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <TextAreaAutoHeight
                                            defaultValue={field.value}
                                            isAutoFocus
                                            sx={{
                                                width: "100%"
                                            }}
                                            resize="none"
                                            onValueChanged={(value) => {
                                                field.onChange(value)
                                            }}

                                        />
                                        {
                                            errors && errors["ten_phu_huynh"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng nhập tên phụ huynh
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}

                            />
                        </FormControl> */}
                        <FormControl sx={{ pt: 1 }}>
                            <FormControl.Label>
                                Cơ quan công tác
                            </FormControl.Label>
                            <Controller
                                name="co_quan_cong_tac"
                                control={control}
                                rules={{
                                    required: {
                                        value: false,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <TextAreaAutoHeight
                                            defaultValue={field.value}
                                            isAutoFocus
                                            sx={{
                                                width: "100%"
                                            }}
                                            resize="none"
                                            onValueChanged={(value) => {
                                                field.onChange(value)
                                            }}

                                        />
                                    </>
                                )}

                            />
                        </FormControl>
                    </>}
                    <FormControl sx={{ pt: 1 }}>
                        <FormControl.Label>Hưởng ưu đãi</FormControl.Label>
                        <Checkbox
                            checked={watch("is_huonguudai", editingData?.is_huonguudai)}
                            onChange={(e) => {
                                setValue("is_huonguudai", e.target.checked);
                            }}
                        />
                    </FormControl>
                    {watch("is_huonguudai", editingData?.is_huonguudai) && (
                        <FormControl sx={{ pt: 1 }}>
                            <FormControl.Label>
                                <Text text="Ưu đãi, miễn giảm" />
                            </FormControl.Label>

                            <Controller
                                name="sf_hinhthucmiengiam_id"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <SelectBoxMienGiam
                                            value={field.value}
                                            isShowClearBtn={true}
                                            onValueChanged={(value) => {
                                                field.onChange(value);
                                            }}
                                            width={"100%"}
                                        />
                                        {
                                            errors && errors["sf_hinhthucmiengiam_id"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng chọn ưu đãi miễn giảm được hưởng
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}
                            />


                        </FormControl>
                    )}
                    <FormControl>
                        <FormControl.Label>
                            {!is_th_dacbiet ? 'Thông tin khác' : 'Lý do'}
                        </FormControl.Label>
                        <Controller
                            name="ghi_chu"
                            control={control}
                            rules={{
                                required: {
                                    value: false,
                                    message: ""
                                }
                            }}
                            render={({ field }) => (
                                <TextAreaAutoHeight
                                    defaultValue={field.value}
                                    isAutoFocus
                                    sx={{
                                        width: "100%"
                                    }}
                                    resize="none"
                                    onValueChanged={(value) => {
                                        field.onChange(value)
                                    }}
                                />
                            )}
                        />
                    </FormControl>
                </Box>

                <ModalActions>

                    <Button
                        text='Base.Label.Close' variant="default"
                        leadingVisual={'center'}
                        size="small"
                        onClick={() => {
                            dispatch(actions.boDoiCongAn.CLOSE_EDIT_MODAL(undefined))
                        }} />
                    <Button
                        text='Base.Label.Update' variant="primary"
                        size="small"
                        type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>

        </Modal>
    );
};

export default ConEmBoDoiCongAnPageEditModal;